import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';
import RadioButton from './RadioButton';
import randInt from '../../../helpers/randInt';

class RadioButtonGroup extends React.Component {
  handleBlur = () => {
    const { onBlur, id } = this.props;
    onBlur(id, true);
  };

  buildChildren = () => {
    const {
      id,
      options,
    } = this.props;

    return options.map((opt) => {
      const { label, value } = opt;
      const hasValue = !!value;
      const identifier = hasValue ? value : randInt();
      return (
        <div className="form__form-group-field" key={identifier}>
          <Field
            component={RadioButton}
            name={id}
            id={identifier}
            label={label}
            value={value}
          />
        </div>
      );
    });
  }

  render() {
    const { error, touched, groupLabel } = this.props;

    return (
      <fieldset>
        <div className="form__form-group">
          <span className="form__form-group-label">{groupLabel}</span>
          <br />
          <div className="form-check form-check-inline w-100">
            {this.buildChildren()}
          </div>
          {touched && error}
        </div>
      </fieldset>
    );
  }
}

RadioButtonGroup.propTypes = {
  error: PropTypes.string,
  id: PropTypes.string.isRequired,
  groupLabel: PropTypes.string,
  onBlur: PropTypes.func,
  options: PropTypes.arrayOf(
    PropTypes.shape({}),
  ).isRequired,
  touched: PropTypes.bool,
};

RadioButtonGroup.defaultProps = {
  error: '',
  onBlur: () => {},
  touched: false,
  groupLabel: null,
};

export default RadioButtonGroup;
